<div cdkTrapFocus aria-live="assertive">
  <div class="modal-header">
    <h2 class="modal-title" i18n="@@modalParkingDetails" id="modal-header">Parking Details</h2>
    <button
      type="button"
      class="close"
      aria-label="Close"
      ngbAutoFocus
      (click)="activeModal.dismiss()"
    >
      <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <app-parking-details [parking]="item" class="parking-details"></app-parking-details>
  </div>
</div>
